/** Shared bits for the partner portal screens. */
import { useQuery } from '@tanstack/react-query';
import { Badge } from '../../components/common/index.jsx';
import * as api from '../../api/partnerPortal.api.js';

export const usePartnerMe = () => useQuery({ queryKey: ['partner', 'me'], queryFn: api.me, staleTime: 5 * 60_000 });

export const HOME = { individual: '/partner/dashboard', admin: '/partner/company-dashboard', member: '/partner/member-dashboard' };

export const SUBMISSION = {
  draft: { tone: 'neutral', label: 'Draft' },
  in_review: { tone: 'sky', label: 'In review' },
  information_requested: { tone: 'amber', label: 'Information requested' },
  approved: { tone: 'emerald', label: 'Approved' },
  rejected: { tone: 'rose', label: 'Rejected' },
};
export const SubmissionBadge = ({ status }) => <Badge tone={SUBMISSION[status]?.tone}>{SUBMISSION[status]?.label ?? status}</Badge>;

export const USER_STATUS = { invited: { tone: 'amber', label: 'Invited' }, active: { tone: 'emerald', label: 'Active' }, inactive: { tone: 'neutral', label: 'Inactive' }, blocked: { tone: 'rose', label: 'Blocked' } };
export const UserStatusBadge = ({ status }) => <Badge tone={USER_STATUS[status]?.tone}>{USER_STATUS[status]?.label ?? status}</Badge>;

export const ROLE_NAME = { individual: 'Individual Partner', admin: 'Company Admin', member: 'Team Member' };

/** Field errors from an API validation failure, plus a readable summary. */
export function errorText(e) {
  const d = (e?.details ?? []).map((x) => x.message ?? x.code).filter(Boolean);
  return d.length ? `${e.message} ${d.join(' · ')}` : (e?.message ?? 'Something went wrong.');
}
export const fieldErrors = (e) => Object.fromEntries((e?.details ?? []).filter((d) => d.field).map((d) => [d.field.replace(/^body\./, ''), d.message ?? d.code]));

export const INDUSTRIES = ['Information Technology', 'Manufacturing', 'Healthcare', 'Financial Services', 'Retail & E-commerce', 'Education', 'Energy & Utilities', 'Telecom', 'Logistics', 'Real Estate', 'Government', 'Other'];
export const TIMELINES = ['Immediate', '1–3 months', '3–6 months', '6–12 months', '12+ months', 'Not sure'];
export const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP', 'AED', 'SGD'];
